import { theme } from '@/utils/theme';

export const classes = {
  list: 'pt-0 mt-0',
  listItemButton:
    'transition-colors duration-100 py-2 px-4 my-1 mx-4 rounded-lg gap-2',
  content: 'w-full',
  primary: 'text-base text-grey-8 dark:text-mauve-1 font-medium truncate',
  secondary:
    'flex items-center gap-4 text-xs text-grey-7 dark:text-mauve-2 mt-1',
  secondaryGroup: 'flex items-center gap-1 min-w-0 truncate',
  secondaryIcon: 'text-sm shrink-0',
};

export const styles = {
  listItemButton: {
    '&': {
      width: 'unset',
      backgroundColor: theme.palette['white'].main,
    },
    '.dark &': {
      backgroundColor: '#332e43',
    },
    '&:hover': {
      backgroundColor: theme.palette['grey-2'].main,
    },
    '.dark &:hover': {
      backgroundColor: 'rgba(255,255,255,0.06)',
    },
    '&.Mui-focusVisible': {
      backgroundColor: theme.palette['grey-2'].main,
    },
    '.dark &.Mui-focusVisible': {
      backgroundColor: 'rgba(255,255,255,0.06)',
    },
  },
};
